export default __webpack_public_path__ + "static/media/background_login.6f870c8d.svg";